import React from "react"
import Grid from "@material-ui/core/Grid"
import { StaticImage } from "gatsby-plugin-image"
import Text from "../components/typography/text"
import Card from "@material-ui/core/Card"
import CardContent from "@material-ui/core/CardContent"
import FormInput from "../components/form-components/form-input"
import useMediaQuery from "@material-ui/core/useMediaQuery"
import { useTheme } from "@material-ui/core"
import Container from "@material-ui/core/Container"
import firebase from "gatsby-plugin-firebase"
import FormWrapper from "../components/form-components/form-wrapper"
import CustomButton from "../components/form-components/button"
import image from "../images/doctor.png"

const DoctorContactUs = () => {
  const theme = useTheme()
  const smDown = useMediaQuery(theme.breakpoints.down("sm"))
  const mdDown = useMediaQuery(theme.breakpoints.down("md"))
  const [expanded, setExpanded] = React.useState(false)

  const handleChange = panel => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false)
  }
  const submitForm = async ({ email, fname,lname, phoneNumber, message, specialty , licensed }) => {
    try {
      const { id } = await firebase
        .firestore()
        .collection("contactUs")
        .add({
          fname: fname || "",
          lname: lname || "",
          email: email || "",
          specialty: specialty ||"",
          licensed :licensed ||"",
          phoneNumber: phoneNumber || "",
          message: message || "",
          createAt: new Date(),
        })
    } catch (error) {
      console.log(error)
    }
  }

  return (
    <div style={{ backgroundColor: "white" }}>
      <Container
        maxWidth="lg"
        style={{
          display: "flex",
          paddingBottom: "80px",
        }}
      >
        <Grid container style={{}}>
          <Grid
            item
            xs={12}
            lg={7}
            style={{
              paddingTop: "150px",
            }}
          >
            <Card
              style={{
                borderRadius: 6,
                height: 600,
                marginTop:"30px",
                boxShadow: smDown
                  ? "unset"
                  : "5px 5px 26px rgba(57 , 120, 228 , 0.13)",
              }}
            >
              <CardContent style={{ paddingBottom: "0px", padding: "0px" }}>
                <Text
                  variant={"h4"}
                  bold
                  style={{
                    position: "relative",
                    left: smDown ? "20px" : "30px",
                    top: smDown ? "unset" : "14px",
                    fontWeight: "bold",
                  }}
                >
                  Contact us
                </Text>
                <br></br>
                {smDown ? null : (
                  <hr style={{ color: "#707070", height: "2px" }}></hr>
                )}
              </CardContent>
              <FormWrapper onSubmit={values => submitForm(values)} reset>
                <Grid
                  container
                  direction="row"
                  spacing={2}
                  justifyContent="center"
                  style={{ alignItems: "center" }}
                >
                  <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                    <Text
                      variant={"body1"}
                      style={{
                        position: "relative",
                        left: smDown ? "20px" : "30px",
                      }}
                    >
                      {" "}
                      Join us as a Doctor ?
                    </Text>
                  </Grid>
                  <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
                    <FormInput
                      type={"text"}
                      name={"fname"}
                      placeholder={" First Name"}
                      required
                      style={{
                        width: smDown ? "100%" : "98%",
                        marginLeft: smDown ? "20px" : "20px",
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
                    <FormInput
                      type={"text"}
                      name={"lname"}
                      placeholder={"Last Name"}
                      required
                      style={{ marginLeft: smDown ? "20px" : "20px" }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
                    <FormInput
                      type={"text"}
                      name={"specialty"}
                      placeholder={"Specialty"}
                      required
                      style={{
                        width: smDown ? "100%" : "98%",
                        marginLeft: smDown ? "20px" : "20px",
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
                    <FormInput
                      type={"text"}
                      name={"licensed"}
                      placeholder={"Licensed States"}
                      required
                      style={{ marginLeft: smDown ? "20px" : "20px" }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                  <FormInput
                    type={"number"}
                    name={"phoneNumber"}
                    placeholder={"Enter number here"}
               
                   
                    required
                    style={{
                      marginLeft: smDown ? "20px" : "25px",
                      marginBottom: "12px",
                    }}
                  />

                  </Grid>
                  <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                  <FormInput
                  type={"email"}
                  name={"email"}
                  placeholder={"Enter email here"}
                
                  required
                  style={{
                    marginLeft: smDown ? "20px" : "25px",
                    marginBottom: "12px",
                  }}
                />
                </Grid>
{/*             
                  <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                  <FormInput
                    type={"text"}
                    name={"aboutus"}
                    placeholder={"Tell us about your project/subject"}
                  
                    required
                    rowsMin={3}
                    rowsMax={4}
                    rows={4}
                    multiline
                    style={{
                      marginLeft: smDown ? "22px" : "25px",
                    }}
                  />
                  </Grid> */}
                  <Grid item lg={12} paddingBottom="20px">
                    <CustomButton
                      style={{
                        backgroundColor: "gray",
                      }}
                    >
                      Send
                    </CustomButton>
                  </Grid>
                </Grid>
              </FormWrapper>
            </Card>
          </Grid>
          {mdDown ? null : (
            <Grid item lg={5} >
              <StaticImage
                src="../images/phonee.png"
                quality={95}
                width={540}
                formats={["auto", "webp", "avif"]}
                alt="contact us"
                style={{
                  top: "10ch",
                }}
              />
            </Grid>
          )}
        </Grid>
      </Container>
    </div>
  )
}
export default DoctorContactUs
